import React from "react";
import {IVettingProgress, VetHistogramEntry} from "../../tevapi/interfaces";
import {Space, Progress, Statistic} from "antd";


export const VettingHistogram: React.FC<{breakdown: VetHistogramEntry}> = ({breakdown}) => {
  return (
    <Space>
      {
        Object.keys(breakdown).map(
          (n_vet_bucket) => (
            <Statistic
              key={n_vet_bucket}
              title={`# of ${n_vet_bucket} Vets`}
              value={breakdown[n_vet_bucket]} 
            />
          )
        )
      }
    </Space>
  );
};


export const VettingProgress: React.FC<{progress: IVettingProgress}> = ({progress}) => {
  return (
    <Progress
      type="circle"
      percent={
        Math.floor((progress.n_vetted_items / progress.n_total_items) * 100)
      }
      size={30}
    />
  )
};
